<nav class="border-gray-200 bg-secondary">
  <div class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4 grid-cols-4">
    <a
      href="https://progetto-sole.com/prenota-solarium-thiene/"
            class="font-adobe items-center px-5 py-2.5 mt-4 sm:mt-6 text-sm font-medium text-center border border-primary text-white bg-primary focus:ring-4 focus:bg-primary sm:w-auto">
      Torna indietro
    </a>
  </div>
</nav>

